module.exports = __webpack_public_path__ + "static/media/detail20.71c67c82.jpg";